import DefaultTabLink from "@/lib/DefaultTabLink";
import { Path } from "@/router";
import classNames from "classnames";
import { sidebarItemActiveClass, sidebarItemHoverClass } from "./sidebarChrome";
import type { NavigationItemProps } from "./types";

export default function ClosedNavigationItem<P extends Path>({
  active = false,
  linkClass,
  icon,
  link,
  onClick
}: NavigationItemProps<P>) {
  const className = classNames(
    "flex justify-center items-center h-14 w-14 rounded-lg",
    {
      [sidebarItemHoverClass]: !active,
      [sidebarItemActiveClass]: active
    },
    linkClass
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classNames(className, "cursor-pointer")}>
        {icon}
      </button>
    );
  }

  return (
    <DefaultTabLink {...link} className={className}>
      {icon}
    </DefaultTabLink>
  );
}
